import React from 'react';
import { Col, ControlLabel, FormControl, Grid, Row } from 'react-bootstrap';
import Card from '../Cards/Card';
import { SnomedPicker } from "../CustomControls/SnomedPicker";
import { ExpandableContent } from '../CustomControls/ExpandableContent';
import { CustomSelect } from "../CustomControls/CustomSelect";

export const ProfessionalDataForm = props => {

    const {
        values,
        handleChange,
        handleBlur,
        setFieldValue,
        setFieldTouched,
        t,
    } = props;

    const jurisdictions = [
        { id: 1, title: "Buenos Aires" },
        { id: 2, title: "CABA" },
        { id: 3, title: "Catamarca" },
        { id: 4, title: "Chaco" },
        { id: 5, title: "Chubut" },
        { id: 6, title: "Córdoba" },
        { id: 7, title: "Corrientes" },
        { id: 8, title: "Entre Ríos" },
        { id: 9, title: "Formosa" },
        { id: 10, title: "Jujuy" },
        { id: 11, title: "La Pampa" },
        { id: 12, title: "La Rioja" },
        { id: 13, title: "Mendoza" },
        { id: 14, title: "Misiones" },
        { id: 15, title: "Neuquén" },
        { id: 16, title: "Río Negro" },
        { id: 17, title: "Salta" },
        { id: 18, title: "San Juan" },
        { id: 19, title: "San Luis" },
        { id: 20, title: "Santa Cruz" },
        { id: 21, title: "Santa Fe" },
        { id: 22, title: "Santiago del Estero" },
        { id: 23, title: "Tierra del Fuego" },
        { id: 24, title: "Tucumán" },
    ];
    const selectedJurisdiction =
        jurisdictions.find(j =>
            j.title.toLowerCase() === values.jurisdiction?.toLowerCase()
        ) || null;


    var defaultSelected = [];
    if (values && values.speciality) {
        defaultSelected.push({ conceptId: "", description: values.speciality });
    }

    return (
        <ExpandableContent title={t("person.professionalData")} expandedAll={true} content="">
            <Card
                className="card-patient-edit card-form"
                content={
                    <Grid fluid>
                        <Row>
                            <Col sm={12}>
                                <Row>
                                    <Col sm={2}>
                                        <ControlLabel>{t("person.registrationNumber")}</ControlLabel>
                                        <FormControl type="text" name="registrationNumber" value={values.registrationNumber ?? ""} onChange={handleChange} onBlur={handleBlur} autoComplete="off" />
                                    </Col>
                                    <Col sm={5}>
                                        <ControlLabel>{t("person.speciality")}</ControlLabel>
                                        <SnomedPicker
                                            defaultSelected={defaultSelected}
                                            id={`speciality`}
                                            name={`speciality`}
                                            placeholder={t("commons.search")}
                                            onChange={setFieldValue}
                                            onBlur={setFieldTouched}
                                            conceptId={"223366009"} //  profesional de la salud (ocupación)
                                        />
                                    </Col>
                                    <Col sm={2}>{/*HAY QUE VOLVER AL DISABLED UNA VEZ QUE VUELVA A ESTAR IMPLENTADA LA API PARA BUSCAR A LOS MEDICOS*/ }
                                        <ControlLabel>{t("person.jurisdiction")}</ControlLabel>
                                        {/*<FormControl type="text" name="jurisdiction" value={values.jurisdiction ?? ""} disabled autoComplete="off" />*/}
                                        <CustomSelect
                                            name="jurisdiction"
                                            value={selectedJurisdiction}
                                            placeholder={t("commons.select")}
                                            options={jurisdictions}
                                            onChange={(name, selected) => setFieldValue(name, selected?.title || "")}
                                            isMulti={false}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Grid>
                }
            />
        </ExpandableContent>
    );
}